import { FEATURE_FLAGS } from '@/constants';
import { cva } from 'class-variance-authority';

const isV2 = FEATURE_FLAGS.ENABLE_SCORECARD_V2;

/**
 * Base styles for the score history card component
 */
export const scoreHistoryCardStyles = cva(
  ['bg-neutral-white', 'flex flex-col gap-2', 'p-6', 'rounded-lg', 'w-full'].join(' '),
  {
    variants: {
      bordered: {
        true: 'border-neutral-gray-200 border shadow-sm',
        false: 'border-none',
      },
    },
    defaultVariants: {
      bordered: false,
    },
  },
);

/**
 * Styles for the score history list container
 */
export const scoreHistoryListStyles = 'bg-neutral-white rounded-lg w-full';

/**
 * Styles for the score entries container
 */
export const scoreEntriesStyles = [
  'bg-neutral-white',
  'rounded-lg',
  'overflow-hidden',
  'py-4',
  'flex',
  'flex-col',
  'gap-2',
  'w-full',
].join(' ');

/**
 * Styles for individual score history rows
 */
export const scoreHistoryRowStyles = [
  'border-neutral-gray-500',
  'border-b',
  'border-solid',
  'flex',
  'items-center',
  'justify-between',
  'pb-2',
  'w-full',
].join(' ');

/**
 * Styles for the score badge/tag
 */
export const scoreBadgeStyles = cva(
  [
    'rounded',
    'px-3',
    'py-0.5',
    'flex',
    'items-center',
    'justify-center',
    'typography-tag',
    'min-w-[85px]',
  ].join(' '),
  {
    variants: {
      color: {
        blue: 'bg-semantic-score-l3 text-neutral-gray-800',
        fail: 'bg-accent-surface-red text-neutral-gray-800',
        green: 'bg-semantic-score-l4 text-neutral-gray-800',
        orange: isV2
          ? 'bg-semantic-score-l2 text-neutral-gray-800'
          : 'bg-semantic-score-legacy-l2 text-neutral-gray-800',
        pass: 'bg-accent-surface-green text-neutral-gray-800 border border-accent-border-green gap-x-1',
        purple: isV2
          ? 'bg-semantic-score-l2 text-neutral-gray-800'
          : 'bg-semantic-score-legacy-l2 text-neutral-gray-800',
        yellow: isV2
          ? 'bg-accent-surface-yellow border border-accent-border-yellow text-accent-border-yellow'
          : 'bg-semantic-score-legacy-l1 text-neutral-gray-800',
      },
    },
    defaultVariants: {
      color: 'purple',
    },
  },
);

/**
 * Styles for the show more button
 */
export const showMoreButtonStyles = [
  '!text-sm',
  'flex',
  'items-center',
  'gap-1',
  'text-neutral-gray-800',
  'typography-body-small',
  'cursor-pointer',
  'hover:text-neutral-black',
  'transition-colors',
  'duration-200',
].join(' ');
